import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  return _openBlock(), _createBlock(_component_el_select, {
    placeholder: _ctx.$t('select.terminal'),
    onChange: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('doParentAction');
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.label,
          value: item.id,
          id: item.label
        }, null, 8, ["label", "value", "id"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["placeholder"]);
}